// Quem está ganhando a rodada em andamento, só com as cartas abertas (a coberta não conta).
// Vale a força mais alta: se as cartas com essa força são de um trio só, a primeira delas está ganhando (carta igual
// do mesmo trio não empacha); se são dos dois trios, todas estão empachadas. A força da manilha inclui o naipe, então
// manilha nunca empata. A mesma conta serve à tela (GANHANDO ou EMPACHADO) e aos bots.
import { SEATS, next, strength, team } from './cards.ts';
import type { Card, Rank, Seat } from './types.ts';

// Quem fecha a rodada (o pé da rodada, que leva o selo PÉ): o último a jogar, o lugar antes de quem abre.
// Na 1ª rodada abre o mão e fecha quem deu as cartas; na 2ª e na 3ª, abre quem venceu a anterior (ou o mão,
// depois de empachar) e fecha quem joga antes dele.
export function quemFecha(abre: Seat): Seat {
  return SEATS.find((s) => next(s) === abre)!;
}

export interface JogadaNaRodada { readonly seat: Seat; readonly card: Card | null; readonly hidden: boolean }
export interface EstadoDaRodada { ganhando: Seat | null; empachados: Seat[] }

export function estadoDaRodada(rodada: { readonly plays: readonly JogadaNaRodada[] }, manilha: Rank): EstadoDaRodada {
  let forca = -1, topo: Seat[] = [];
  for (const p of rodada.plays) {
    if (p.hidden || p.card === null) continue;
    const f = strength(p.card, manilha);
    if (f > forca) { forca = f; topo = [p.seat]; } else if (f === forca) topo.push(p.seat);
  }
  if (!topo.length) return { ganhando: null, empachados: [] };
  return new Set(topo.map(team)).size === 1 ? { ganhando: topo[0]!, empachados: [] } : { ganhando: null, empachados: topo };
}
